import React from 'react'
import { assessMission } from '../missionQuality'

/**
 * Advisory quality hints under a mission textarea (homelab-kb #32).
 *
 * Never blocks. The mission is the primary matching signal since Phase 10D,
 * so this is worth more visual weight than the grey character counter it
 * replaced — but a nag the user cannot dismiss by saving is worse than a
 * thin mission, so it stays amber, not red.
 */
export default function MissionHints({ mission, state }) {
  const text = mission || ''
  const { tooShort, hints } = assessMission(text, state)

  return (
    <div className="space-y-2">
      <p className="text-xs text-gray-500">
        {text.trim().length} characters{tooShort && ' (minimum 20)'}
      </p>
      {hints.length > 0 && (
        <div className="rounded-lg bg-amber-50 border border-amber-200 p-3 space-y-1.5">
          {hints.map(hint => (
            <p key={hint} className="text-xs text-amber-800 leading-relaxed">
              {hint}
            </p>
          ))}
          <p className="text-[11px] text-amber-700/80 pt-0.5">
            Optional. You can save and refine this later.
          </p>
        </div>
      )}
    </div>
  )
}
